import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class SettingsService {
    static fetchSettings() {
        return lastValueFrom(BaseService.get(`settings`));
    }
    static saveSettings(dto) {
        return lastValueFrom(BaseService.save(`settings`, dto));
    }
}
